import BaseActionTypes from "../../base/BaseActionTypes";

const RESOURCE = "Merchant";

const MerchantActionTypes = {
  ...BaseActionTypes(RESOURCE),
};

export default MerchantActionTypes;
